import type { Address } from "viem"
import type { Config } from "wagmi"

import type { TransactionReturnType } from "@/domains/on-chain/types"
import { merge } from "@/domains/on-chain"

import type { IMergeNftActions } from "./interfaces"

/**
 * Adapter that implements IMergeNftActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class MergeNftActionsAdapter implements IMergeNftActions {
  async merge(params: {
    account: Address
    chainId: number
    config: Config
    vestedAddress: Address
    fromTokenId: number
    toTokenId: number
  }): Promise<TransactionReturnType> {
    return await merge(params)
  }
}
